import { render, staticRenderFns } from "./Dialog_GiveTeacherToSemester.vue?vue&type=template&id=3d6ced7e&"
import script from "./Dialog_GiveTeacherToSemester.vue?vue&type=script&lang=js&"
export * from "./Dialog_GiveTeacherToSemester.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports